import { useQuery } from '@tanstack/react-query';
import { ProjectImageStoragesAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const projectImageStoragesAPI = new ProjectImageStoragesAPI(axios);

export const useProjectImageStoragesQuery = () => {
    return useQuery({
        queryKey: ['project/image-storages'],
        queryFn: async () => projectImageStoragesAPI.getProjectImageStorages()
    });
};
